import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "@/services/axios.js";

// Thunk pour charger les sites
export const fetchSites = createAsyncThunk(
    'sites/fetchSites',
    async () => {
        const response = await api.get('/api/sites/stats');
        return response.data;
    }
);

// Thunk pour charger l'historique d'un site
export const fetchSiteHistory = createAsyncThunk(
    'sites/fetchHistory',
    async (siteId) => {
        const response = await api.get(`/api/sites/${siteId}/history`);
        return { siteId, history: response.data };
    }
);

// Thunk pour les statistiques globales
export const fetchGlobalStats = createAsyncThunk(
    'sites/fetchGlobalStats',
    async () => {
        const response = await api.get('/api/sites/stats/global');
        return response.data;
    }
);

const sitesSlice = createSlice({
    name: "sites",
    initialState: {
        items: [],
        loading: false,
        lastUpdate: null,
        error: null,
        history: {}, // Stocker l'historique par site
        globalStats: null,
        realtimeStats: {}
    },
    reducers: {
        setSites(state, action) {
            state.items = action.payload;
            state.loading = false;
            state.lastUpdate = new Date().toISOString();
            state.error = null;
        },
        setLoading(state) {
            state.loading = true;
        },
        setError(state, action) {
            state.loading = false;
            state.error = action.payload;
        },
        updateSiteRealtime(state, action) {
            const siteKey = action.payload.siteKey;
            const index = state.items.findIndex(
                site => site.siteKey === siteKey || site.id.toString() === siteKey
            );

            if (index !== -1) {
                // Mettre à jour les statistiques
                state.items[index] = {
                    ...state.items[index],
                    todayVisites: action.payload.todayVisites || state.items[index].todayVisites,
                    totalVisites: action.payload.totalVisites || state.items[index].totalVisites,
                    onlineVisitors: action.payload.onlineVisitors || 0,
                    peakVisitors: action.payload.peakVisitors || state.items[index].peakVisitors || 0,
                    lastUpdated: action.payload.lastUpdated || new Date().toISOString(),
                    status: action.payload.status || state.items[index].status,
                    uptime: action.payload.uptime || state.items[index].uptime,
                    responseTime: action.payload.responseTime || state.items[index].responseTime
                };

                state.lastUpdate = new Date().toISOString();
            }
        },
        updateSiteStatus(state, action) {
            const { siteKey, status, responseTime } = action.payload;
            const index = state.items.findIndex(
                site => site.siteKey === siteKey || site.id.toString() === siteKey
            );

            if (index !== -1) {
                state.items[index].status = status;
                if (responseTime) {
                    state.items[index].responseTime = responseTime;
                }
                state.items[index].lastChecked = new Date().toISOString();
            }
        },
        setRealtimeStats(state, action) {
            state.realtimeStats = action.payload;
        },
        updateHistory(state, action) {
            const { siteId, history } = action.payload;
            state.history[siteId] = history;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSites.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchSites.fulfilled, (state, action) => {
                state.loading = false;
                state.items = action.payload;
                state.lastUpdate = new Date().toISOString();
            })
            .addCase(fetchSites.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(fetchSiteHistory.fulfilled, (state, action) => {
                const { siteId, history } = action.payload;
                state.history[siteId] = history;
            })
            .addCase(fetchGlobalStats.fulfilled, (state, action) => {
                state.globalStats = action.payload;
            });
    }
});


export const {
    setSites,
    setLoading,
    setError,
    updateSiteRealtime,
    updateSiteStatus,
    setRealtimeStats,
    updateHistory
} = sitesSlice.actions;

export default sitesSlice.reducer;
